import $ from 'jquery'
import { breakpoints } from './_site'
import scrollMonitor from 'scrollMonitor'
import scrollify from 'scrollify'
require('paroller.js')

export const timeout = {}
export const monitorAnimations = ($monitor) => {
  $monitor.each(function () {
    var $el = $(this),
      watcher,
      offset = $(window).width() < breakpoints.md ? -150 : -250

    // create monitor
    watcher = scrollMonitor.create($el, offset)

    // watcher.fullyEnterViewport(function () {
    watcher.enterViewport(function () {
      var $el = $(this.watchItem)

      // active section
      $el.addClass('scroll-active')

      // remove listener
      this.destroy()
    })

    $el.data('watcher', watcher)
  })
}
export const applyScrollify = () => {
  if ($('body').data('ignore-scrollify') != 1) {
    $.scrollify({
      section: '.section',
      interstitialSection: '.footer',
      sectionName: '',
      touchScroll: false,
      offset: 1,
      setHeights: false,
    })
  }

  $('section.section a.arrow').on('click', function (event) {
    event.preventDefault()

    $.scrollify.next()
  })
}

// export const applyScrollify = () => {
//   if ($('body').data('ignore-scrollify') != 1) {
//     console.log('yo')
//     $.scrollify({
//       section: '.section',
//       scrollSpeed: 1500,
//       overflowScroll:true,
//       standardScrollElements: ".footer",
//       // interstitialSection: '.footer',
//       // sectionName: '',
//       // touchScroll: false,
//       offset: 0,
//       // before: function() {
//       //   $('.section').removeClass('active')
//       //   current = $.scrollify.current();
//       //   current.addClass('active')
//       // },
//       setHeights: false,
//     })
//   }
// }

export const binds = () => {
  $('.paroller, [data-paroller-factor]').paroller()

  applyScrollify()
}
